import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import Year from '../../../../shared/Year';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
import DownStream from '../../../orgManager/Utils/AssetManagement/Utils/DownStream';

const AssetDownManagement: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  return (
    <>
      {searchParam.get('selectedYear') && (
        <>
          <Year setSelectedYear={setSelectedYear} />
          <DownStream
            selectedYear={selectedYear}
            isConfigurator={true}
            planPropertyKey={accessModule.externalStakeholders}
            planVehicleKey={accessModule.scope3}
          />
        </>
      )}
    </>
  );
};

export default AssetDownManagement;
